module.exports = __webpack_public_path__ + "fcd410c7.svg";